import React, { useEffect } from "react";
import commonStore from "../Store/marco/commonStore";

export function useActiveEditor({
  store,
  isEdit,
  openWarning,
  clearEdit,
  save,
}) {
  useEffect(() => {
    // ① 註冊 active editor
    commonStore.setActiveEditor({
      isEdit,
      openWarning,
      save: () => store.executeSaveHandler(),
      clearEdit,
    });

    // ② 註冊此頁面的 save 行為
    store.registerSaveHandler(save);

    // ③ 離開頁面時清乾淨
    return () => {
      commonStore.clearActiveEditor();
      store.clearSaveHandler();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
